<template>
    <form v-loading="isLoading" @submit.prevent="send">
        <div class="form-row">
            <has-error :form="form" field="deal_id" class="d-block"/>
            <has-error :form="form" field="sale_items" class="d-block"/>
            <table class="table">
                <thead>
                <tr>
                    <td colspan="6" class="text-center">Список доп оборудования</td>
                </tr>
                <tr>
                    <th>#</th>
                    <th>Наименование</th>
                    <th>Цена</th>
                    <th>Кол-во</th>
                    <th>Сумма</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(i, k) in sale_items" :key="k">
                    <td>
                        {{k+1}}
                    </td>
                    <td><input type="text" class="form-control form-control-sm" :id="'name' + _uid + k" v-model="i.name" required style="width: 100%"><has-error :form="form" :field="'sale_items.' + k +'.name'" class="d-block"/></td>
                    <td><input type="text" class="form-control form-control-sm" :id="'price' + _uid + k" v-model="i.price" required style="width: 60px"><has-error :form="form" :field="'sale_items.' + k +'.price'" class="d-block"/></td>
                    <td><input type="text" class="form-control form-control-sm" :id="'quantity' + _uid + k" v-model="i.quantity" required style="width: 35px"><has-error :form="form" :field="'sale_items.' + k +'.quantity'" class="d-block"/></td>
                    <td><input type="text" class="form-control form-control-sm" :id="'amount' + _uid + k" :value="i.price * i.quantity" disabled style="width: 60px"><has-error :form="form" :field="'sale_items.' + k +'.amount'" class="d-block"/></td>
                    <td>
                        <button @click="removeItem(k)" type="button" class="btn btn-link btn-sm p-0"><i class="fas fa-times text-gray"></i></button>
                    </td>
                </tr>
                <tr>
                    <td colspan="6" class="p-0">
                        <button @click="addItem" type="button" class="btn btn-link btn-sm">Добавить <i class="fas fa-plus text-success"></i></button>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="form-group col-6">
                <label class="mb-0" :for="'document_date' + _uid">Дата</label>
                <input type="date" class="form-control" :id="'document_date' + _uid" v-model="document_date" required>
                <has-error :form="form" field="document_date" class="d-block"/>
            </div>
            <div class="form-group col-6">
                <label class="mb-0" :for="'sale_amount' + _uid">Сумма доп оборудования</label>
                <input type="text" class="form-control" :id="'sale_amount' + _uid" :value="sale_amount" required disabled>
                <has-error :form="form" field="sale_amount" class="d-block"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12">
                <button type="submit" v-if="mode === 'create' && $hasPermission('additional_agreements.create')" class="btn btn-primary">Создать</button>
                <button type="submit" v-if="mode === 'edit' && $hasPermission('additional_agreements.update')" class="btn btn-primary">Сохранить</button>
            </div>
        </div>
    </form>
</template>

<script>
import Form from "vform";
import AffiliateProgramSelect from "../affiliate_programs/AffiliateProgramSelect";
import PlatformHelper from "../../helpers/platform";

export default {
    name: "AdditionalAgreementForm",
    props: {
        agreement: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['create', 'edit'].indexOf(value) !== -1
            }
        },
    },
    data: () => ({
        form: new Form({}),
        isLoading: false,

        id: null,
        deal_id: null,
        document_date: moment().format('YYYY-MM-DD'),
        sale_items: [],
    }),
    mounted() {
        if (this.agreement.id !== undefined) this.id = this.agreement.id;
        if (this.agreement.deal_id !== undefined) this.deal_id = this.agreement.deal_id;
        if (this.agreement.document_date !== undefined) this.document_date = this.agreement.document_date;
        if (this.agreement.sale_items !== undefined) this.sale_items = this.agreement.sale_items;
        // if (this.agreement.sale_amount !== undefined) this.sale_amount = this.agreement.sale_amount / 100;
    },
    computed: {
        sale_amount() {
            return _.sum(this.sale_items.map(i => i.price * i.quantity));
        }
    },
    methods: {
        addItem() {
            this.sale_items.push({
                name: "",
                quantity: 1,
                price: 5000,
                amount: 0,
            })
        },
        removeItem(k) {
            // let list = _.cloneDeep(this.sale_items);
            this.sale_items = this.sale_items.filter((i, index) => index !== +k);
        },
        makeForm() {
            this.form = new Form({
                id: this.id,
                deal_id: this.deal_id,
                document_date: this.document_date,
                sale_items: this.sale_items.map(i => {
                    i.amount = i.price * i.quantity;
                    return i;
                }),
                sale_amount: this.sale_amount,
            });
        },
        send() {
            if (this.agreement && this.agreement.id) {
                this.update();
            } else {
                this.create();
            }
        },
        create(){
            let self = this;
            this.makeForm();
            this.isLoading = true;
            this.form.post('/api/additional_agreements')
                .then(response => {
                    self.$emit('created', response.data);
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Создано',
                        duration: 2000,
                    });
                    self.$emit('saved', response.data);
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка при создании, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
        update(){
            let self = this;
            this.makeForm();
            this.isLoading = true;
            this.form.put('/api/additional_agreements/' + this.agreement.id)
                .then(response => {
                    self.$emit('updated', response.data);
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Сохранено',
                        duration: 2000,
                    });
                    self.$emit('saved', response.data);
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
    }
}
</script>

<style scoped>

</style>
